import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { AdminHeader } from "../../../components/adminHeader/adminHeader";
import { Button } from "../../../components/button/button";
import { Spring } from "../../../components/spring/spring";
import { PageLoader } from "../../../components/loader/pageLoader";
import { InputBlock } from "../addKpiTask/InputBlock";
import { useAnimatedNavigate } from "../../../hooks/useAnimatedNavigate";
import KpiAPI from "../../../api/KpiAPI";

import { Text } from "../../../components/text/text";

export const SuperadminEditKPITaskPage = () => {
    const { cafeId, taskId } = useParams();

    const [category, setCategory] = useState("");
    const [categoryError, setCategoryError] = useState(false);

    const [goal, setGoal] = useState(0);
    const [goalError, setGoalError] = useState(false);

    const [date, setDate] = useState(new Date());
    const [completedRevenue, setCompletedRevenue] = useState(0);

    const [loading, setLoading] = useState(false);
    const [initialLoading, setInitialLoading] = useState(true);

    const navigate = useAnimatedNavigate();

    useEffect(() => {
        setGoalError(false);
    }, [goal]);

    useEffect(() => {
        setCategoryError(false);
    }, [category]);

    useEffect(() => {
        if (!cafeId || !taskId) return;

        setInitialLoading(true);
        KpiAPI
            .fetchAdminKpiScheme(cafeId)
            .then((res) => {
                const currentTask = res.find(item => item.id === Number(taskId));
                if (!currentTask) {
                    navigate(`/superadmin/cafe/${cafeId}/kpi`);
                    return;
                }

                setCategory(currentTask.categoryName);
                setGoal(currentTask.goalRevenue);
                setCompletedRevenue(currentTask.completedRevenue);
                setDate(new Date(currentTask.kpiDate));
            })
            .catch(console.error)
            .finally(() => setInitialLoading(false));
    }, [cafeId, taskId, navigate]);

    const validateData = () => {
        let error = false;

        if (goal <= 0) {
            setGoalError(true);
            error = true;
        }

        if (category.length <= 1) {
            setCategoryError(true);
            error = true;
        }

        return error;
    }

    const onSave = () => {
        if (!cafeId || !taskId) return;
        if (validateData()) return;

        setLoading(true);
        KpiAPI
            .updateKpiScheme(cafeId, taskId, {
                name: category,
                goal,
                date,
                completed: completedRevenue,
            })
            .then(() => navigate(`/superadmin/cafe/${cafeId}/kpi`))
            .catch(console.error)
            .finally(() => setLoading(false));
    }

    if (initialLoading) {
        return <PageLoader />;
    }

    return (
        <>
            <AdminHeader title="Редактировать план" />

            <Text as="div" variant="body" className="page_description" >
                Измените категорию, план или дату начала для KPI задачи.
            </Text>

            <InputBlock
                type="text"
                title="Категория продаж"
                value={category}
                setValue={setCategory}
                error={categoryError}
            />

            <InputBlock
                type="number"
                title="План по продажам"
                value={goal}
                setValue={setGoal}
                error={goalError}
            />

            <InputBlock
                type="date"
                title="Дата начала"
                value={date.toISOString().split("T")[0]}
                setValue={(val) => {
                    try {
                        const newDate = new Date(val);
                        newDate.toISOString();
                        setDate(newDate);
                    } catch {
                        setDate(prev => prev);
                    }
                }}
            />

            <Spring />

            <Button
                text="Сохранить"
                onClick={onSave}
                disabled={loading}
            />
        </>
    )
}
